module.exports = __webpack_public_path__ + "media/packs/site/assets/images/illust_ok-f6cd5ee21fa6e348f1df0b93b96cb6e2.png";